module.exports = __webpack_public_path__ + "img/img_8.b647a795.jpeg";